import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';
import { createNonDisplayOptionDefinition } from '~src/spacesPlatform/models/sort/SortOptionsHelper';

import { OrderKeys } from '../../../../spacesPlatform/models/OrderKeys';

export const siteUserSortOptions: OptionsDictionary = {
  'userName': createNonDisplayOptionDefinition('userName', OrderKeys.username),
  'displayName': createNonDisplayOptionDefinition('displayName', OrderKeys.displayName),
  'siteRole': createNonDisplayOptionDefinition('siteRole', OrderKeys.siteRole),
  'lastSignIn': createNonDisplayOptionDefinition('lastSignIn', OrderKeys.lastSignIn),
  'domainName': createNonDisplayOptionDefinition('domainName', OrderKeys.domainName),
};
